import { Grid, Typography } from "../../basics"
import { InvestorProfileChip } from "../InvestorProfileChip"
import { IClientCardProps } from "./types"
import { StyledClientCard } from "./styled"

const ClientCard = (props: IClientCardProps) => {
    return (
        <StyledClientCard>
            <Grid container justifyContent="space-between" alignItems={"center"}>
                <Grid item>
                    <Typography variant="body1">
                        {props.clientName}
                    </Typography>
                    {/* <Typography variant="h5" mt={1}>
                        {props.clientAmount}
                    </Typography> */}
                    <InvestorProfileChip profile={props.clientInvestProfile} />
                </Grid>
                <Grid item>
                    <Typography variant="h5" mt={1}>
                        Valor da oportunidade:
                    </Typography>
                    <Typography variant="h5" mt={1}>
                        {props.opportunityVolume}
                    </Typography>
                </Grid>
            </Grid>
        </StyledClientCard>
    )
}

export { ClientCard }

